import { Icon, IconName } from 'app/common/components/controls';
import { forTemplate } from 'app/common/lib/util/i18n';
import {
  PopoverMenu,
  PopoverMenuButton,
} from 'app/gamma/src/components/popover/popover-menu';
import React from 'react';

import styles from './channel-switcher.less';
import {
  getMyChannels,
  getIsDevChannels,
} from 'app/gamma/src/selectors/channels';
import { useSelector } from 'react-redux';

const format = forTemplate('header_channel_picker');

interface ChannelListProps {
  onSelectHydraChooser: () => void;
  onSelectChannel: (channelName: string) => void;
}

export const ChannelList = ({
  onSelectHydraChooser,
  onSelectChannel,
}: ChannelListProps) => {
  const channels = useSelector(getMyChannels);
  const lastChannelIndex = channels.length - 1;
  const dev = useSelector(getIsDevChannels);

  return (
    <PopoverMenu className={styles.popoverMenu}>
      {channels.map((channel, i) => {
        return (
          <PopoverMenuButton
            appendSeparator={dev && i === lastChannelIndex}
            key={channel.name}
            onClick={() => onSelectChannel(channel.name)}
          >
            {channel.displayName}
            {channel.active && <Icon small name={IconName.Check} />}
          </PopoverMenuButton>
        );
      })}
      {dev && (
        <PopoverMenuButton
          key="devLink"
          onClick={() => onSelectHydraChooser()}
          title={format('pick-a-version')}
        />
      )}
    </PopoverMenu>
  );
};
